import Vue from "vue";
import { ActionTree } from "vuex";
import axios from "@/axios-config/default";
import { IRootState } from "@/store/types";
import { PContentsMutationsNames } from "./enums";
import { IProgramContentState } from ".";
import { IUuidsPayload } from "@/store/types";
import { IProgramContent } from "@/models/programcontent";

export const actions: ActionTree<IProgramContentState, IRootState> = {
    fetchProgramContentsList({ commit }, ids: IUuidsPayload): void {
        axios
            .get(
                Vue.prototype.$environmentService.getServicePath(
                    "programcontents"
                ),
                {
                    params: {
                        serviceProviderUuid: ids.uuidSP,
                        contentProviderUuid: ids.uuidCP,
                    },
                }
            )
            .then((response) => {
                if (response.status === 200) {
                    // mutation to storage programContents list
                    commit(PContentsMutationsNames.SetList, response.data);
                }
            })
            .catch((error) => {
                // mutation to storage error
                commit(PContentsMutationsNames.SetError, error);
            });
    },
    setSelectedProgramContent(
        this,
        { commit },
        programContent: IProgramContent
    ) {
        commit(PContentsMutationsNames.SetSelected, programContent);
    },
    setProgramContentsList(
        this,
        { commit },
        programContent: IProgramContent[]
    ) {
        commit(PContentsMutationsNames.SetList, programContent);
    },
    resetProgramContentsState({ commit }): void {
        commit(PContentsMutationsNames.ResetState);
    },
};
